import React from 'react'

export default function EntryRightIcon(props) {

    return (
        <>
            <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.14331 10.9307L2.06136 6.89673L0.308594 8.62888L6.14331 14.395L18.1759 2.50388L16.4232 0.771729L6.14331 10.9307Z" fill="white" />
            </svg>
        </>
    )
}
